<!--
  @description 时间轴状态的显示
  @param statusList时间轴列表项
  @param currentIndex当前状态的索引
-->
<template>
  <div class="state_axis">
    <div class="state_axis_item"
          v-for="(item, index) in statusList"
          :key="item.name"
          :class="{'flex_item': index !== (statusList.length -1),
                  'state_done': index <= currentIndex
          }">
      <div class="state_item">
        <div class="state_item_icon">
          <i :class="index <= currentIndex ? 'el-icon-check' :'el-icon-time'"></i>
        </div>
        <slot :row="item"></slot>
        <!--  name="otherInfo" -->
      </div>
      <div class="state_line"></div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    statusList: {
      type: Array,
      default: () => {
        return []
      }
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {}
}
</script>
<style lang='scss' scoped>
.state_axis{
  display: flex;
  justify-content: center;
  .state_axis_item{
    display: flex;
    // flex: 1;
    .state_item{
      text-align: center;
      color: #ccc;
      .state_item_icon{
        width: 50px;
        height: 50px;
        line-height: 42px;
        border-radius: 50px;
        font-size: 32px;
        border: 4px solid #ccc;
        .el-icon-check, .state_item_icon{
          font-weight: bold;
        }
      }
    }
    .state_line{
      flex: 1;
      height: 2px;
      background: #ccc;
      margin-top: 24px;
    }
    &:last-child{
      .state_line{
        display: none;
      }
    }
  }
  .state_done{
    .state_item{
      color: #1ABC9C;
      .state_item_icon{
        color: #1ABC9C;
        border-color: #1ABC9C;
      }
    }
    .state_line{
      background: #1ABC9C;
    }
  }
  .flex_item{
    flex: 1;
  }
}
</style>
